import { render } from "./InfoIconRed.vue?vue&type=template&id=9e994624"
import script from "./InfoIconRed.vue?vue&type=script&lang=js"
export * from "./InfoIconRed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__